import { TIMESTAMP_TYPES, TIMESTAMP_TYPE_CREATED_AT } from '~/vue_shared/components/resource_lists/constants';
import ProjectsListItem from './projects_list_item.vue?vue3';
export default {
    name: 'ProjectsList',
    components: {
        ProjectsListItem
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        showProjectIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        listItemClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: ''
        },
        timestampType: {
            type: String,
            required: false,
            default: TIMESTAMP_TYPE_CREATED_AT,
            validator (value) {
                return TIMESTAMP_TYPES.includes(value);
            }
        },
        includeMicrodata: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'click-avatar',
        'click-stat',
        'click-topic',
        'hover-stat',
        'hover-visibility',
        'refetch'
    ]
};
